export const en = {
  meta: {
    home: {
      title: "KAZIM'S | Premium Leaf Tea",
      desc: "Discover KAZIM'S premium leaf tea sourced from the renowned tea regions of Siliguri, New Jalpaiguri, Darjeeling and Guwahati.",
    },
    about: {
      title: "About KAZIM'S | Premium Leaf Tea",
      desc: "Founded on 1st September 2026, KAZIM'S brings you premium leaf tea, pure from the hills of Siliguri, New Jalpaiguri, Darjeeling and Guwahati.",
    },
    ourTea: {
      title: "Our Tea | KAZIM'S Premium Leaf Tea",
      desc: "Explore Kazims Flavor Fusion Tea — a premium leaf tea blend sourced from Siliguri, New Jalpaiguri, Darjeeling and Guwahati. Order online with COD.",
    },
    product: {
      title: "Kazims Flavor Fusion Tea | KAZIM'S",
      desc: "Kazims Flavor Fusion Tea — premium leaf tea, 1 KG pack at ₹360, sourced from the renowned tea regions of India. Order online with COD.",
    },
    contact: {
      title: "Contact Us | KAZIM'S Premium Leaf Tea",
      desc: "Call, WhatsApp or email KAZIM'S for premium leaf tea enquiries. Bhatakua Patti, Imamganj, Mau, Uttar Pradesh.",
    },
    faq: {
      title: "FAQ | KAZIM'S Premium Leaf Tea",
      desc: "Frequently asked questions about KAZIM'S premium leaf tea — sourcing, pack sizes, ordering, COD and contact.",
    },
    privacy: { title: "Privacy Policy | KAZIM'S", desc: "How KAZIM'S handles your information." },
    terms: { title: "Terms & Conditions | KAZIM'S", desc: "Terms and conditions for the KAZIM'S website." },
    shipping: { title: "Shipping Information | KAZIM'S", desc: "Shipping, dispatch and tracking information for KAZIM'S premium leaf tea." },
    refund: { title: "Return / Refund Information | KAZIM'S", desc: "Return and refund information for KAZIM'S premium leaf tea." },
  },
  nav: {
    home: "Home",
    about: "About",
    ourTea: "Our Tea",
    contact: "Contact",
    explore: "Explore Tea",
    menuOpen: "Open menu",
    menuClose: "Close menu",
  },
  hero: {
    eyebrow: "A Premium Indian Tea House",
    line1: "Premium Leaf Tea,",
    line2: "Pure From The Hills.",
    sub: "Pure, aromatic and carefully selected tea leaves sourced from the renowned tea regions of India.",
    ctaPrimary: "Explore Our Tea",
    ctaSecondary: "Discover KAZIM'S",
    est: "Est. 1 September 2026",
    place: "Mau · Uttar Pradesh · India",
    scroll: "Scroll",
  },
  marquee: { label: "Our Tea Origins" },
  intro: {
    eyebrow: "The Brand",
    heading: "More Than Tea. An Experience.",
    body: "Founded on 1st September 2026, Kazims brings premium leaf teas sourced from Siliguri, New Jalpaiguri, Darjeeling, and Guwahati. Our focus is simple — pure, aromatic, and exceptional tea that elevates every cup.",
    cta: "Discover KAZIM'S",
    badge: "Est. 2026",
    imgAlt: "Fresh tea leaves being carefully plucked by hand",
  },
  origins: {
    eyebrow: "Tea Origins",
    heading: "From Four Renowned Regions",
    body: "Every cup of KAZIM'S begins in the tea heartlands of North Bengal and Assam. Each region lends its own character to our blend.",
  },
  signature: {
    eyebrow: "Signature Blend",
    heading: "Our Signature Tea",
    highlightsTitle: "What makes it special",
    priceLabel: "Price",
    sizeLabel: "Pack Size",
    viewDetails: "View Details",
    buyNow: "Buy Now",
    imgAlt: "Kazims Flavor Fusion Tea served in a dark cup with a golden rim",
  },
  quality: {
    eyebrow: "The KAZIM'S Standard",
    heading: "Held To A Higher Standard",
    items: [
      { t: "Premium Leaf Tea", d: "Whole, well-graded leaves chosen for character and purity." },
      { t: "Carefully Selected", d: "Every lot is checked with care before it earns the KAZIM'S name." },
      { t: "Rich Aroma", d: "A deep, fragrant cup that fills the room before the first sip." },
      { t: "Exceptional Taste", d: "Smooth, layered flavour that stays light on the palate." },
    ],
  },
  homeCta: {
    eyebrow: "Order & Enquiries",
    heading: "Where tea is more than a drink — it's an experience.",
    body: "Order online with Cash on Delivery, or choose Prepaid — we confirm payment with you before dispatch. For anything else, reach us directly.",
    call: "Call KAZIM'S",
    whatsapp: "WhatsApp KAZIM'S",
  },
  footer: {
    tagline: "Premium leaf tea, pure from the hills.",
    quick: "Quick Links",
    contactTitle: "Contact",
    phoneLabel: "Phone",
    emailLabel: "Email",
    addressTitle: "Address",
    follow: "Instagram",
    track: "Track Order",
    rights: "© 2026 KAZIM'S. All Rights Reserved.",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    shipping: "Shipping Information",
    refund: "Return / Refund Information",
  },
  ourTeaPage: {
    eyebrow: "Our Tea",
    heading: "The KAZIM'S Collection",
    body: "Our premium leaf teas, sourced with care from the renowned tea regions of India. More blends will join the collection soon.",
    noteTitle: "Ordering made simple",
    note: "Order online with Cash on Delivery, or choose Prepaid — we confirm payment with you first. Bulk enquiries: call or WhatsApp 6306859310, or email kazims5050@gmail.com.",
    brewTitle: "Brewing Recommendation",
    brew: [
      { t: "Boil & rest", d: "Boil one cup of fresh water and let it settle for a moment." },
      { t: "Add the leaves", d: "Add one spoon of Kazims Flavor Fusion Tea per cup." },
      { t: "Steep covered", d: "Cover and let it brew for 3–4 minutes so the aroma opens fully." },
      { t: "Strain & serve", d: "Strain, add milk and sugar to your taste, and serve hot." },
    ],
    moreTitle: "More blends on the way",
    moreBody: "Product 2 and Product 3 will be added to this page soon. For current availability, contact us directly.",
    imgAlt: "Loose leaf tea resting in a golden strainer on a wooden tray",
  },
  productPage: {
    overview: "Overview",
    highlights: "Highlights",
    origin: "Origin",
    category: "Category",
    size: "Pack Size",
    price: "Price",
    availability: "Available Quantity",
    availabilityValue: "In stock — 1 KG pack",
    buy: "Buy Now",
    inlineNote: "Cash on Delivery available across India · Prepaid orders confirmed after payment collection",
    notice: "Online ordering is currently unavailable. Please contact KAZIM'S directly for product availability and purchase information.",
    call: "Call Now",
    whatsapp: "WhatsApp Us",
    email: "Email Us",
    back: "All Teas",
    moreTitle: "More from KAZIM'S",
    moreBody: "New blends will be added to this page soon. For current availability, contact us directly.",
  },
  checkout: {
    title: "Place Your Order",
    sub: "Cash on Delivery is available across India. Prepaid orders are confirmed after our team collects payment with you directly.",
    name: "Full Name",
    namePh: "Your full name",
    phone: "Mobile Number",
    phonePh: "10-digit mobile number",
    email: "Email",
    emailOpt: "(optional)",
    emailPh: "Your email",
    address: "Address",
    addressPh: "House no., street, landmark",
    city: "City",
    cityPh: "Your city",
    state: "State",
    statePh: "Your state",
    pincode: "PIN Code",
    pincodePh: "6-digit PIN code",
    qty: "Quantity",
    payment: "Payment Method",
    cod: "Cash on Delivery",
    codNote: "Pay when your tea arrives at your door.",
    prepaid: "Prepaid",
    prepaidNote: "We will contact you to collect payment before dispatch.",
    total: "Total",
    place: "Place Order",
    placing: "Placing Order…",
    successT: "Order Placed",
    successB: "Thank you! Your order has been received and will be confirmed shortly. Keep this Order ID to track your delivery.",
    orderIdLabel: "Order ID",
    viewOrder: "View Order & Tracking",
    continue: "Continue Shopping",
    error: "Please check your details — full name, 10-digit mobile number, complete address and a valid 6-digit PIN code are required.",
  },
  orderPage: {
    thanks: "Thank you for your order",
    orderLabel: "Order ID",
    statusLabel: "Current Status",
    items: "Items",
    total: "Order Value",
    payment: "Payment",
    paymentStatus: {
      cod_pending: "Pay on delivery (COD)",
      payment_pending: "Payment to be collected",
      paid: "Paid",
    },
    deliverTo: "Delivery Details",
    awb: "AWB",
    courier: "Courier",
    noTracking: "Tracking will appear here once your shipment is dispatched.",
    activities: "Updates",
    trackUrl: "Open live tracking",
    notFound: "We could not find this order. Please check the Order ID.",
    needHelp: "Need help with this order?",
    call: "Call KAZIM'S",
    whatsapp: "WhatsApp KAZIM'S",
    home: "Back to Home",
    statuses: {
      New: "New",
      Processing: "Processing",
      Shipped: "Shipped",
      "Out for Delivery": "Out for Delivery",
      Delivered: "Delivered",
      Cancelled: "Cancelled",
    },
  },
  track: {
    title: "Track Your Order",
    sub: "Enter the Order ID from your confirmation page or WhatsApp message.",
    placeholder: "e.g. KZ1A2B3C4D",
    button: "Track Order",
    notFound: "No order found for this ID. Please check and try again.",
  },
  aboutPage: {
    eyebrow: "About Us",
    heading: "About KAZIM'S",
    lead1: "Premium leaf tea, pure from the hills.",
    lead2: "Founded on 1st September 2026, Kazims brings premium leaf teas sourced from Siliguri, New Jalpaiguri, Darjeeling, and Guwahati.",
    lead3: "Our focus is simple — pure, aromatic, and exceptional tea that elevates every cup.",
    quote: "Kazims. Where tea is more than a drink — it's an experience.",
    story: {
      n: "01",
      t: "Our Story",
      b: "KAZIM'S began with a simple thought — bring the hills' finest leaf tea home to Mau. We started on 1st September 2026, and every pack we sell still carries the same promise we began with: pure, aromatic, honest tea.",
    },
    philosophy: {
      n: "02",
      t: "Our Philosophy",
      b: "We treat tea as an experience, not just a drink. Our way is to do fewer things, better — good leaves, a careful blend, and a cup worth remembering. No shortcuts, no noise, just tea done properly.",
    },
    qualityF: {
      n: "03",
      t: "Our Quality Focus",
      b: "Every lot is examined for leaf, aroma and taste before it is packed. If a batch does not meet our standard, it does not carry the KAZIM'S name. Quality is our only advertisement.",
    },
    sourcing: {
      n: "04",
      t: "Our Tea Sourcing",
      b: "Our teas come from Siliguri, New Jalpaiguri, Darjeeling and Guwahati — regions renowned for fine tea. Each lends its own strength, aroma and character, brought together in one balanced blend.",
    },
    imgAlt: "Hands picking fresh tea leaves in a green tea garden",
  },
  contactPage: {
    eyebrow: "Contact Us",
    heading: "Let's Talk Tea",
    body: "Reach KAZIM'S directly — call, WhatsApp, email or Instagram, whichever suits you. We are happy to help with availability and purchase.",
    infoTitle: "Direct Contact",
    callLabel: "Call KAZIM'S",
    waLabel: "WhatsApp KAZIM'S",
    emailLabel: "Email KAZIM'S",
    instaLabel: "Instagram",
    addressTitle: "Our Address",
    mapTitle: "Find Us",
    formTitle: "Send an Enquiry",
    formBody: "Fill in the form and we will get back to you. You can also send your enquiry straight to our WhatsApp.",
    name: "Name",
    namePh: "Your full name",
    mobile: "Mobile Number",
    mobilePh: "10-digit mobile number",
    email: "Email",
    emailPh: "Your email",
    emailOpt: "(optional)",
    message: "Message",
    messagePh: "What would you like to know?",
    send: "Send Enquiry",
    sending: "Sending…",
    viaWa: "Send via WhatsApp instead",
    successT: "Enquiry received",
    successB: "Thank you! Your enquiry has reached us — we will get back to you shortly. Need a quicker reply? Send it on WhatsApp too.",
    errorB: "Your enquiry could not be sent. Please try again, or reach us directly on WhatsApp or by phone.",
    formError: "Please check your details — name, a valid mobile number and a message are required.",
  },
  faqPage: {
    eyebrow: "FAQ",
    heading: "Frequently Asked Questions",
    body: "Everything you may want to know about KAZIM'S and our tea.",
    items: [
      {
        q: "What is KAZIM'S?",
        a: "KAZIM'S is a premium leaf tea brand founded on 1st September 2026, based in Imamganj, Mau, Uttar Pradesh. We offer carefully selected leaf teas sourced from the renowned tea regions of India.",
      },
      {
        q: "Where is KAZIM'S tea sourced from?",
        a: "Our teas are sourced from Siliguri, New Jalpaiguri, Darjeeling and Guwahati — regions renowned for their fine tea.",
      },
      {
        q: "What is Flavor Fusion Tea?",
        a: "Kazims Flavor Fusion Tea is our signature premium leaf tea — a carefully crafted blend of teas from Siliguri, New Jalpaiguri, Darjeeling and Guwahati. Each leaf is selected for purity, aroma and character, creating a smooth, layered cup that is rich in flavour yet light on the palate.",
      },
      {
        q: "What pack size is currently available?",
        a: "Kazims Flavor Fusion Tea is currently available in a 1 KG pack, priced at ₹360.",
      },
      {
        q: "How can I purchase KAZIM'S tea?",
        a: "Order directly on this website — open Kazims Flavor Fusion Tea and tap Buy Now, then choose Cash on Delivery or Prepaid. For bulk enquiries, call or WhatsApp 6306859310.",
      },
      {
        q: "Do you offer COD?",
        a: "Yes — Cash on Delivery is available for online orders across India, delivered through our courier partners.",
      },
      {
        q: "Do you offer online payment?",
        a: "Online payment is currently unavailable. Prepaid orders are confirmed after our team collects payment with you directly (e.g., via UPI).",
      },
      {
        q: "How can I contact KAZIM'S?",
        a: "Call or WhatsApp us at 6306859310, email kazims5050@gmail.com, follow @KAZIMS50 on Instagram, or visit us at Bhatakua Patti, Daya Rai, Near BTI Masjid, Imamganj, Mau, Uttar Pradesh - 275101.",
      },
    ],
  },
  legal: {
    privacy: {
      title: "Privacy Policy",
      intro: "KAZIM'S respects your privacy. This policy explains what information we receive through this website and how it is used.",
      sections: [
        { h: "Information We Collect", p: ["When you place an order or send an enquiry, we receive the details you provide: your name, mobile number, email (if shared), shipping address and order details. We do not collect online payment information, because online payment is currently unavailable."] },
        { h: "How We Use It", p: ["Your information is used only to process your order, deliver it through our courier partners and respond to your questions. We do not sell or rent your information to anyone."] },
        { h: "Third-Party Services", p: ["Orders are shipped via courier partners connected through Shiprocket, who receive the delivery details needed to reach you. This website also embeds a Google Maps location and links to WhatsApp, Instagram and your phone dialler; their own privacy policies apply when you use them."] },
        { h: "Data Retention", p: ["Order and enquiry details are retained as long as needed to serve you and keep simple records. You may ask us to delete your details at any time by contacting us."] },
        { h: "Contact", p: ["For any privacy question or request, contact us at 6306859310 or kazims5050@gmail.com."] },
      ],
    },
    terms: {
      title: "Terms & Conditions",
      intro: "Welcome to the KAZIM'S website. By using this site, you agree to the terms below.",
      sections: [
        { h: "About KAZIM'S", p: ["KAZIM'S is a partnership business based at Bhatakua Patti, Daya Rai, Near BTI Masjid, Imamganj, Mau, Uttar Pradesh - 275101, India, founded on 1st September 2026."] },
        { h: "Product Information", p: ["Product details — names, descriptions, pack sizes and prices — are provided for information. Currently, Kazims Flavor Fusion Tea is available in a 1 KG pack at ₹360. Packshots are representative; slight natural variation in tea is normal."] },
        { h: "Ordering & Payment", p: ["Orders can be placed on this website with Cash on Delivery, or as Prepaid — for prepaid orders, our team collects payment with you directly (e.g., via UPI) before dispatch. Online payment on the website is currently unavailable. An order is confirmed once we verify it; we may cancel orders we cannot verify."] },
        { h: "Pricing", p: ["Prices are shown in Indian Rupees and may change without notice. The price applicable to your purchase is the one shown at the time you place your order."] },
        { h: "Website Content", p: ["All content on this website — text, imagery and design — belongs to KAZIM'S. Please do not copy or reuse it without permission."] },
        { h: "Contact", p: ["For any question about these terms, reach us at 6306859310 or kazims5050@gmail.com."] },
      ],
    },
    shipping: {
      title: "Shipping Information",
      intro: "Here is how delivery of KAZIM'S tea works.",
      sections: [
        { h: "Placing an Order", p: ["Orders are placed directly on this website — choose Cash on Delivery or Prepaid at checkout. Prepaid orders are confirmed after payment is collected with you directly."] },
        { h: "Dispatch & Delivery", p: ["Once your order is confirmed, it is packed with care and handed to our courier partners. Delivery times vary by destination and are shared with your tracking details."] },
        { h: "Tracking Your Order", p: ["Every confirmed order gets an Order ID. Once dispatched, the AWB number, courier and live tracking updates appear on your order page — you can also use the Track Order page any time."] },
        { h: "Questions", p: ["For anything about delivery to your area, contact us at 6306859310 or kazims5050@gmail.com."] },
      ],
    },
    refund: {
      title: "Return / Refund Information",
      intro: "We want every cup of KAZIM'S tea to be worth it. Here is how returns and refunds work.",
      sections: [
        { h: "If Something Is Wrong", p: ["If your tea arrives damaged or is not the product you ordered, please contact us as soon as possible after delivery — call or WhatsApp 6306859310, or email kazims5050@gmail.com, and share your Order ID and photos if you can."] },
        { h: "How We Make It Right", p: ["Once we understand the issue, we will work with you on a suitable resolution — a replacement or a refund, depending on the situation. COD orders can be refused at the door if the package is damaged; prepaid amounts are returned for verified problems."] },
        { h: "Honest Expectations", p: ["Natural tea can vary slightly in look and aroma between lots; this is normal and not a defect."] },
        { h: "Contact", p: ["For any return or refund question, reach us at 6306859310 or kazims5050@gmail.com."] },
      ],
    },
  },
  notFound: {
    title: "Page Not Found",
    body: "The page you are looking for does not exist or has moved.",
    home: "Back to Home",
  },
};
